export default class ViaCEP {
  async buscarCEP (cep) {
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      const endereco = await response.json()
      return endereco
    } catch (error) {
      return null
    }
  }
}
